import React from "react";

export const LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/78844932-dbdb-4c25-a158-66c0da2bcfa2/images/1425b1bde107ae22ecec7cac335039d7ca9694b41bf25e0e2fdfa788c256868f.png";

/**
 * Logo — circular Duunari emblem (clipboard + tools, hazard stripe ring).
 * Use `aura` for a neon-yellow glow behind the mark.
 */
export const Logo = ({ size = 40, className = "", aura = false, testId = "duunari-logo" }) => {
  return (
    <span
      data-testid={testId}
      className={`relative inline-flex shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      {aura && (
        <span
          aria-hidden="true"
          className="absolute inset-0 -m-3 pointer-events-none"
          style={{
            background:
              "radial-gradient(circle, rgba(255,234,0,0.55) 0%, rgba(255,234,0,0.18) 45%, rgba(255,234,0,0) 75%)",
            filter: "blur(14px)",
          }}
        />
      )}
      <img
        src={LOGO_URL}
        alt="Duunari logo"
        width={size}
        height={size}
        className="relative w-full h-full object-contain"
        style={{ borderRadius: "50%" }}
        draggable={false}
      />
    </span>
  );
};
